import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 20000 });

export const getConfig = () => client.get("/config").then((r) => r.data);
export const getPlans = () => client.get("/plans").then((r) => r.data);
export const getPhones = () => client.get("/phones").then((r) => r.data);
export const createOrder = (payload) => client.post("/orders", payload).then((r) => r.data);
export const getOrder = (id) => client.get(`/orders/${id}`).then((r) => r.data);
export const markOrderPaid = (id) => client.post(`/orders/${id}/mark-paid`).then((r) => r.data);
export const createContact = (payload) => client.post("/contacts", payload).then((r) => r.data);
export const getAdminOrders = (token) =>
  client.get("/admin/orders", { headers: { "x-admin-token": token } }).then((r) => r.data);
export const deleteAdminOrders = (token, ids) =>
  client.post("/admin/orders/delete", { ids }, { headers: { "x-admin-token": token } }).then((r) => r.data);
export const getAdminContacts = (token) =>
  client.get("/admin/contacts", { headers: { "x-admin-token": token } }).then((r) => r.data);

export const formatEUR = (value) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(Number(value || 0));

// Carica un'immagine (multipart) e ritorna { url } (URL relativo /api/images/...)
export const uploadImage = (token, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return client
    .post("/admin/upload-image", fd, { headers: { "x-admin-token": token } })
    .then((r) => r.data);
};

// Risolve gli URL immagine: i percorsi relativi /api/... vengono prefissati con il
// backend URL; gli URL esterni (http...) restano invariati.
export const resolveImageUrl = (src) => {
  if (!src) return src;
  if (src.startsWith("/api/")) return `${BACKEND_URL}${src}`;
  return src;
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const waLink = (number, text) => {
  const digits = String(number || "").replace(/\D/g, "");
  if (!digits) return "";
  const base = `https://wa.me/${digits}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
};

// --- Analytics & session ---
export const getSessionId = () => {
  try {
    let sid = localStorage.getItem("ct-sid");
    if (!sid) {
      sid = (window.crypto && crypto.randomUUID && crypto.randomUUID()) || `s-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      localStorage.setItem("ct-sid", sid);
    }
    return sid;
  } catch (e) {
    return "anon";
  }
};

export const trackVisit = (path) =>
  client
    .post("/track/visit", { path, referrer: document.referrer || "", session_id: getSessionId() })
    .then((r) => r.data)
    .catch(() => {});

export const getLiveStats = () => client.get("/stats/live").then((r) => r.data);

// --- Admin management ---
export const getAdminAnalytics = (token) => client.get("/admin/analytics", { headers: { "x-admin-token": token } }).then((r) => r.data);
export const getAdminSettings = (token) => client.get("/admin/settings", { headers: { "x-admin-token": token } }).then((r) => r.data);
export const updateAdminSettings = (token, data) => client.put("/admin/settings", data, { headers: { "x-admin-token": token } }).then((r) => r.data);
export const updateAdminPlan = (token, slug, data) => client.put(`/admin/plans/${slug}`, data, { headers: { "x-admin-token": token } }).then((r) => r.data);
export const createAdminPhone = (token, data) => client.post("/admin/phones", data, { headers: { "x-admin-token": token } }).then((r) => r.data);
export const updateAdminPhone = (token, id, data) => client.put(`/admin/phones/${id}`, data, { headers: { "x-admin-token": token } }).then((r) => r.data);
export const deleteAdminPhone = (token, id) => client.delete(`/admin/phones/${id}`, { headers: { "x-admin-token": token } }).then((r) => r.data);
